calculate = (policie) => {
    const amount = policie.amount
    const company = policie.company
    const has_garantees = policie.has_garantees
    const expiration = policie.expiration_higher
    let excess = 0
    if(!expiration && !has_garantees) {
        ranges = [240404.84, 300506.05]
        multipliers = [2/1000, 1/1000, 0.25/1000]
        excess = calcultateExcess(ranges, multipliers, amount)
    }
    if(expiration && has_garantees && amount < 90151.82) {
        ranges = [48080.97]
        multipliers = [4.5/1000, 1.5/1000]
        excess = calcultateExcess(ranges, multipliers, amount)
    }
    let ranges = []
    if ((expiration && !has_garantees) || (expiration && has_garantees && amount >= 90151.82) || (!expiration && has_garantees)) {
        ranges = [90151.82, 150253.03, 300506.05]
        multipliers = [3/1000, 2/1000, 1/1000, 0.25/1000]
        excess = calcultateExcess(ranges, multipliers, amount)
    }
    return parseFloat(excess)
}

calcultateExcess = (ranges, multipliers, amount) => {
    ranges = adjustRanges(ranges, amount)
    let excess = 0
    for (let i = 0; i < ranges.length; i++) {
        if (i - 1 < 0) {
            excess += (ranges[i] * multipliers[i]) < 12.02 ? 12.02 : ranges[i] * multipliers[i]
        } else {
            excess += (ranges[i] - ranges[i - 1]) * multipliers[i]
        }
    }
    return excess.toFixed(2)
}

adjustRanges = (ranges, amount) => {
    let position = 0
    for (let i = 0; i < ranges.length; i++) {
        if (amount > ranges[i]) {
            position = i + 1
        }
    }
    ranges.splice(position, 0, amount)
    ranges.splice(position + 1, ranges.length)
    return ranges
}

module.exports = calculate


// WEBPACK FOOTER //
// ./resources/assets/js/components/budgetary/policies/honorary.js